import { Tab, Tabs } from "@mui/material";
import {
  navigationTabStyles,
  navigationTabWrapperStyles,
} from "./NavigationHeader.styles";

export interface NavigationHeaderModule {
  label: string;
  action: () => void;
}

interface NavigationHeaderProps {
  navigationHeaders: NavigationHeaderModule[];
  selectedTab: number;
  onTabChange: (index: number) => void;
}

function NavigationHeader(props: NavigationHeaderProps) {
  const { navigationHeaders, selectedTab, onTabChange } = props;

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    const index = parseInt(newValue.replace("menu-tab-", ""), 10);
    onTabChange(index);
    navigationHeaders[index]?.action();
  };

  return (
    <Tabs
      value={`menu-tab-${selectedTab}`}
      onChange={handleChange}
      aria-label="menu-navigation"
      sx={navigationTabWrapperStyles}
    >
      {navigationHeaders.map(
        (header: NavigationHeaderModule, index: number) => {
          return (
            <Tab
              key={header.label}
              label={header.label}
              sx={navigationTabStyles}
              value={`menu-tab-${index}`}
              disableRipple
            />
          );
        },
      )}
    </Tabs>
  );
}
export default NavigationHeader;
